export const useIsProduction = () => {
    return !(window.location.hostname.includes('localhost') || window.location.hostname.includes('appsdevteam'));
}